module.exports = __webpack_public_path__ + "static/fun-time/audio/karta1//2_bye_bye.mp3";